<div class="main-content">
    <div class="container-fluid">
        <!-- <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-squirrel">
                        <h4 class="card-title">{{this.translate.data['CURRENTDATABASEVERSION'] | translate}}</h4>
                    </div>
                    <div class="card-body">
                        <div>{{databaseVersion}}</div>
                        <div class="sq-migrate-button pull-right">
                            <button mat-raised-button class="btn btn-squirrel" (click)="migrateMainDatabase()"
                                matBadge="{{databaseVersion}}">{{this.translate.data['SQUIRRELMAINDB'] |
                                translate}}</button>
                            <button mat-raised-button class="btn btn-squirrel" (click)="migrateGenericDatabases()"
                                matBadge="{{databaseVersion}}">{{this.translate.data['SQUIRRELGENERICDB'] |
                                translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-squirrel">
                        <h4 class="card-title">{{this.translate.data['LEGACYSQUIRRELMIGRATIONS'] | translate}}</h4>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-12">
                                <form [formGroup]="squirrelEnvironmentForm">
                                    <mat-form-field class="example-full-width">
                                        <input matInput
                                            placeholder="{{this.translate.data['ENVIRONMENTURL'] | translate}}"
                                            formControlName="url" required>
                                        <!-- <button mat-button color="primary" matSuffix mat-icon-button
                                            (click)="addSquirrelEnvironment()">
                                            <mat-icon>add</mat-icon>
                                        </button> -->
                                    </mat-form-field>
                                    <a>
                                        <button mat-raised-button class="btn btn-squirrel pull-left" style="margin-top: 0px;margin-left: 0px" matTooltip="Squirrel Umgebung erfassen"
                                                (click)="addSquirrelEnvironment()">Umgebung erfassen</button>
                                    </a>
                            </form>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="squirrel-environments-table" style="height: 480px; overflow: auto;">
                                    <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                                        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                                        <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                                            Squirrel's API rate limit has been reached. It will be reset in one minute.
                                        </div>
                                    </div>
                                    <ag-grid-angular class="ag-theme-balham" style="width:100%; height: 100%;"
                                        [overlayLoadingTemplate]="overlayLoadingTemplate" [gridOptions]="gridOptions"
                                        (gridReady)="onGridReady($event)" [frameworkComponents]="frameworkComponents"
                                        >
                                    </ag-grid-angular>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-10">
                                <mat-form-field class="example-full-width">
                                    <mat-label>{{this.translate.data['SELECTENVIRONMENT'] | translate}}</mat-label>
                                    <mat-select [(ngModel)]="selectedEnvironment" required>
                                        <mat-option *ngFor="let environment of rowData" [value]="environment">
                                            {{environment.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2">
                                <span style="color: red; font-weight: 600"> {{migrationError}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-10">
                                <mat-form-field class="example-full-width">
                                    <mat-label>{{this.translate.data['SELECTENVIRONMENTTENANT'] | translate}}</mat-label>
                                    <mat-select [(ngModel)]="selectedEnvironmentTenant" required>
                                        <mat-option *ngFor="let tenant of rowDataTenant" [value]="tenant">
                                            {{tenant.name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-2">
                                <span style="color: red; font-weight: 600"> {{migrationError}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="sq-migrate-button pull-right">
                                    <button mat-raised-button class="btn btn-squirrel" (click)="migrateUsers()"
                                        matBadge="{{unMigratedUsers}}">{{this.translate.data['MIGRATEUSERS'] | translate}}
                                    </button>
                                    <button mat-raised-button class="btn btn-squirrel"
                                        (click)="migrateProjects()">{{this.translate.data['MIGRATEPROJECTS'] | translate}}
                                    </button>
                                    <!-- <button mat-raised-button class="btn btn-squirrel" (click)="sendEmail()"
                                        matBadge="{{mailingCount}}">{{this.translate.data['BTNUSERPROJECTSMIGRATEDEMAIL'] |
                                        translate}}
                                    </button> -->
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>